import CommonIFrame from '../atoms/CommonIFrame';

const BaseVolumePlanning = () => {
    return (
        <CommonIFrame
            src="https://assortment-and-basevolume.lovable.app/base-volume-v4/"
            title="Base Volume Planning"
        />
    );
};

export default BaseVolumePlanning;
